import { BaseWidgetView } from './BaseWidgetView';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';
import { AlertsNavigationParams, NavigationHelper, NavigationItem } from '@nirvana/shared/navigation';
import { exitFullscreen, isBrowserFullscreen, onExitFullscreenError } from '../utils/fullscreen.utils';

export abstract class BaseThreatWidgetView extends BaseWidgetView {
  protected navigationHandlers: Array<(event: any) => void> = [];
  protected dashboardMetaData: any;

  protected addDrillDownHandlers(targets: Array<Target>, timeRange: number, canDrillDown: boolean) {
    if (!NavigationHelper.shouldAddHandlers(this.dependencies.Ext)) {
      return;
    }

    const navigationItems: Array<NavigationItem> = [
      this.getNavigationItemForTitle(targets, timeRange),
      ...this.getNavigationItemsForWidgetBody(targets, timeRange),
    ];

    let navigationHandler;
    if (canDrillDown) {
      navigationHandler = (event, navigationParams) => {
        if (BaseWidgetView.isSuccessState(this.$wrapper)) {
          if (isBrowserFullscreen()) {
            exitFullscreen(() => {}, onExitFullscreenError.bind(this));
          }

          NavigationHelper.navigateToAlerts(this.dependencies.Ext, <AlertsNavigationParams>navigationParams);
        }
      };
    }

    NavigationHelper.updateNavigableItems(navigationItems, this.navigationHandlers, navigationHandler);
  }

  protected abstract getNavigationItemForTitle(targets: Array<Target>, timeRange: number): NavigationItem;

  protected abstract getNavigationItemsForWidgetBody(targets: Array<Target>, timeRange: number): Array<NavigationItem>;

  protected updateDrillDownHandlers() {
    if (this.dashboardMetaData) {
      const { targets, timeRange, canDrillDown } = this.dashboardMetaData;
      this.addDrillDownHandlers(targets, timeRange, canDrillDown);
    }
  }
}
